import Vue from 'vue';
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib';
import VuetifyToast from 'vuetify-toast-snackbar-ng';
// import '@fortawesome/fontawesome-free/css/all.css'; // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import moment from 'moment';

import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css';

Vue.filter('formatDate', (value) => {
	if (value) {
		return moment(String(value)).format('MM/DD/YYYY HH:mm:ss');
	}
});

import VueTimeago from 'vue-timeago';

Vue.use(VueTimeago, {
	name: 'Timeago', // Component name, `Timeago` by default
	locale: 'en', // Default locale
});

Vue.use(PerfectScrollbar);
VBtn.options.props.ripple.default = false;
Vue.use(Vuetify, {
	components: {
		VSnackbar,
		VBtn,
		VIcon,
	},
});

Vue.use(VuetifyToast, {
	x: 'center', // default
	showClose: false,
	closeIcon: 'fa-times',
	timeout: 3000,
});

const vuetify = new Vuetify({
	theme: {
		themes: {
			light: {
				primary: '#5C8DF5',
				secondary: '#FC5D7D',
				// icon: '#6B7786',
				error: '#eb747D',
			},
		},
	},
	icons: {
		iconfont: 'fa',
	},
});

Vue.use(VuetifyDialog, {
	context: {
		vuetify,
	},
});

export default vuetify;
